import styled from 'styled-components'


export const BlockDescription = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  @media (min-width:768px){
    flex-direction: inherit;
    ${props => props.inverted && 'flex-direction: row-reverse;'};
  }
`

export const Content = styled.div`
  @media (min-width:768px){
    padding: 0 3rem;
  }
`
export const Title = styled.h2`
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1rem;
  position: relative;
  @media (min-width:768px){
    margin-bottom: 1.5rem;
  }
`
export const Text = styled.p`
  margin-bottom: 1rem;
`
export const CtaWrapper = styled.div`
  button {
    padding: 0;
    margin-bottom: 1rem;
    color: ${props => props.theme.colors.thirdary};
  }
`

export const Date = styled.div`
  color: ${props => props.theme.colors.thirdary};
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const Column = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  @media (min-width:768px){
    width: 50%;
    display: block;
  }

  img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

`

export const ReactPlayerWrapper = styled.div`
  margin: 2rem 0;
`

export const IconPlayWrapper = styled.div`
  margin-left: .5rem;
  position: absolute;
  right: 1rem;
  bottom: 0;
  border-radius: 50%;
  color: ${props => props.theme.colors.black.secondary};

  svg {
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
  }

  &:hover{

    svg {
      color: ${props => props.theme.colors.primary};
      cursor: pointer;
      animation: pulse 1.5s infinite;
    }
  
 } 

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }

    70% {
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }



`


export const VideoButtonWrapper = styled.div`
  margin-bottom: 1rem;

`





